export const CORE_LESSON_COMPLETION_FLAG =
  'feature_LEARN-27700_core-lesson-completion-updates'
